(() => {
  // Calendar arithmetic uses UTC dates constructed from the shop's Madrid day.
  // This avoids DST shifts and customer timezone differences.
  function madridDay(now) {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit'
    }).formatToParts(now);
    const value = type => Number(parts.find(part => part.type === type).value);
    return new Date(Date.UTC(value('year'), value('month') - 1, value('day')));
  }

  function addBusinessDays(date, count) {
    const result = new Date(date);
    while (count > 0) {
      result.setUTCDate(result.getUTCDate() + 1);
      if (result.getUTCDay() !== 0 && result.getUTCDay() !== 6) count--;
    }
    return result;
  }

  function deliveryWindow(now = new Date(), limitedStock = false) {
    const day = madridDay(now);
    const earliest = addBusinessDays(day, 2);
    const latest = addBusinessDays(day, 3);
    const format = date => new Intl.DateTimeFormat('es-ES', {
      timeZone: 'UTC', day: 'numeric', month: 'long',
      ...(earliest.getUTCFullYear() !== latest.getUTCFullYear() ? {year: 'numeric'} : {})
    }).format(date);
    const start = earliest.getUTCMonth() === latest.getUTCMonth() && earliest.getUTCFullYear() === latest.getUTCFullYear()
      ? earliest.getUTCDate() : format(earliest);
    return {earliest, latest, text: `${limitedStock ? 'Última Unidad' : 'En stock'}, llega del ${start} al ${format(latest)}`};
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {madridDay, addBusinessDays, deliveryWindow};
  }
  if (typeof customElements === 'undefined' || customElements.get('dm-delivery-window')) return;

  customElements.define('dm-delivery-window', class extends HTMLElement {
    connectedCallback() {
      this.update();
      this.refresh = setInterval(() => this.update(), 60000);
    }
    disconnectedCallback() { clearInterval(this.refresh); }
    update() {
      const label = this.querySelector('[data-delivery-text]');
      let text = deliveryWindow(new Date(), this.hasAttribute('limited-stock')).text;
      const prefix = this.getAttribute('delivery-prefix');
      if (prefix) text = `${prefix} ${text.split('llega ')[1]}`;
      if (this.hasAttribute('date-only')) text = deliveryWindow().text.split('llega ')[1];
      if (label && label.textContent !== text) label.textContent = text;
    }
  });
})();
